module.exports = __webpack_public_path__ + "img/proprietary-hemp-extract.7e403b06.jpg";